import React from 'react';
import { useTheme } from '../context/ThemeContext';

const FilterChips = ({ 
  clientFilter, 
  setClientFilter, 
  hideZeroCompetitors, 
  setHideZeroCompetitors, 
  sortBy, 
  setSortBy,
  searchQuery,
  setSearchQuery,
  onClearAll,
  hideSearch = false
}) => {
  const { isDark } = useTheme();
  const getChips = () => {
    const chips = [];

    // Search query chip - only if not hidden
    if (!hideSearch && searchQuery && searchQuery.trim()) {
      chips.push({
        id: 'search',
        label: `Query: "${searchQuery}"`,
        onRemove: () => setSearchQuery('')
      });
    }

    // Client visibility chip
    if (clientFilter !== 'all') {
      const labels = {
        found: 'Client mentioned',
        notfound: 'Client not found'
      };
      chips.push({
        id: 'client',
        label: labels[clientFilter],
        onRemove: () => setClientFilter('all')
      });
    }

    // Hide zero competitors chip
    if (hideZeroCompetitors) {
      chips.push({
        id: 'competitors',
        label: 'Hide no competitors',
        onRemove: () => setHideZeroCompetitors(false)
      });
    }

    // Sort chip
    if (sortBy !== 'position') {
      const labels = {
        default: 'Sort: Default',
        engine: 'Sort: Engine'
      };
      chips.push({
        id: 'sort',
        label: labels[sortBy],
        onRemove: () => setSortBy('position')
      });
    }

    return chips;
  };

  const chips = getChips();

  if (chips.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-wrap items-center gap-2 p-4 glass-dark border-b ${isDark ? 'border-white/10' : 'border-gray-200'}`}>
      <span className={`text-mono text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>Active filters:</span>
      {chips.map((chip) => (
        <span
          key={chip.id}
          className="glass-badge-success inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-mono text-sm"
        >
          {chip.label}
          <button
            onClick={chip.onRemove}
            className="flex items-center justify-center w-4 h-4 rounded-full glass-interactive transition-colors focus:outline-none"
            aria-label={`Remove ${chip.label} filter`}
          >
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </span>
      ))}
      {chips.length > 1 && (
        <button
          onClick={onClearAll}
          className="btn-glass text-mono text-sm px-3 py-1 rounded-lg hover:scale-105 transform transition-all"
        >
          Clear all
        </button>
      )}
    </div>
  );
};

export default FilterChips;